export const AUTH_REQUEST = 'AUTH_REQUEST';
export const AUTH_REFRESH_TOKEN = 'AUTH_REFRESH_TOKEN';
export const AUTH_SUCCESS = 'AUTH_SUCCESS';
export const AUTH_ERROR = 'AUTH_ERROR';
export const AUTH_LOGOUT = 'AUTH_LOGOUT';
export const AUTH_USER_REQUEST = 'AUTH_USER_REQUEST';
export const AUTH_LOCALE = 'AUTH_LOCALE';
